'use strict';

window.CFC = window.CFC || {};
window.CFC.Header = (function($) {
  let $hamburger;
  let focusLinks;
  let focusManagement;
  
  function init() {
    focusManagement = window.Plaintext.FocusManagement;
    initHamburger();
    initSearchToggle();
    
    $hamburger = $('#hamburgerToggle');
    focusLinks = focusManagement.createFocusLinks([
      [ $hamburger[0], $('.topNav__homeLink')[0] ],
      [ $('.topNav__homeLink')[0], $('#topNavSearch')[0] ],
      [ $('#topNav__searchSubmit')[0], $('#menu-header-menu li:first a')[0] ],
      [ $('#menu-header-menu li:last a')[0], $('.topNav__langWrap a')[0] ],
      [ $('.topNav__langWrap a')[0], $hamburger[0] ],
    ]);
  }
  
  function initHamburger() {
    $('#hamburgerToggle').on('click', () => ($('body').hasClass('hamburger-open') ? closeHamburger() : openHamburger()));
    focusManagement.onEsc(closeHamburger);
  }
  
  function openHamburger() {
    $('body').addClass('hamburger-open');
    $hamburger.attr('aria-expanded', 'true');
    focusManagement.enableFocusLinks(focusLinks);
    focusManagement.pushFocus();
  }
  
  function closeHamburger() {
    if (!$('body').hasClass('hamburger-open')) { return; }
    
    $('body').removeClass('hamburger-open');
    $hamburger.attr('aria-expanded', 'false');
    focusManagement.disableFocusLinks(focusLinks);
    focusManagement.popFocus();
  }
  
  function initSearchToggle() {
    $('#headerSearchToggle').on('click', () => {
      var $wrap = $('#headerSearchWrap');
      
      // We're closing - clear the input
      if ($wrap.hasClass('search--open')) {
        $('#topNavSearch').val('');
      }
      
      $wrap.toggleClass('search--open');
    });
  }
  
  $(init);
})(jQuery);